<template>
    <el-dialog
        :title="(isForm ? (roleId ? '修改应用' : '添加应用') : '查看应用') + dialogTitle"
        :close-on-click-modal="false"
        width="640px"
        :model-value="modelValue"
        @close="closed"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : {}" label-width="120px" style="max-width: 580px">
            <el-row>
                <el-col :span="24" v-if="!isForm">
                    <el-form-item label="应用Id">
                        <div>{{ formData.app_id }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="!isForm">
                    <el-form-item label="密钥">
                        <div style="word-break: break-all">{{ formData.secret }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="应用名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="应用回调地址" prop="callback_url">
                        <el-input v-if="isForm" v-model="formData.callback_url"></el-input>
                        <span v-else>{{ formData.callback_url }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系人" prop="contact">
                        <el-input v-if="isForm" v-model="formData.contact"></el-input>
                        <span v-else>{{ formData.contact }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-if="isForm" v-model="formData.phone"></el-input>
                        <span v-else>{{ formData.phone }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-if="isForm" v-model="formData.email"></el-input>
                        <span v-else>{{ formData.email }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="状态">
                        <el-radio-group v-if="isForm" v-model="formData.status">
                            <el-radio :value="1">正常</el-radio>
                            <el-radio :value="0">停用</el-radio>
                        </el-radio-group>
                        <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="!isForm">
                    <el-form-item label="显示状态">
                        <div>{{ formData.visible == 1 ? '显示' : '隐藏' }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="排序" prop="list_order">
                        <el-input-number
                            v-if="isForm"
                            v-model="formData.list_order"
                            :min="0"
                            :max="999999"
                            type="number"
                            controls-position="right"
                        ></el-input-number>
                        <span v-else>{{ formData.list_order }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="备注">
                        <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                        <div v-else>{{ formData.remark }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="!isForm">
                    <el-form-item label="创建时间">
                        <div>{{ formData.create_time }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="!isForm">
                    <el-form-item label="更新时间">
                        <div>{{ formData.update_time }}</div>
                    </el-form-item>
                </el-col>

                <el-col :span="24" v-if="!isForm">
                    <el-form-item label="私钥">
                        <div style="word-break: break-all">{{ formData.private_key }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="!isForm">
                    <el-form-item label="公钥">
                        <div style="word-break: break-all">{{ formData.public_key }}</div>
                    </el-form-item>
                </el-col>

                <el-col v-if="props.roleId" :span="24" class="checkbox-group">
                    <el-form-item label="接口列表">
                        <el-checkbox-group v-if="isForm" v-model="formData.api_lists">
                            <el-checkbox
                                v-for="(item, index) in apiOptionListsData"
                                :key="index"
                                :label="item"
                                name="api_lists"
                            ></el-checkbox>
                        </el-checkbox-group>
                        <span v-else>{{ formData.api_lists }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onActivated, ref, watch } from 'vue'
import { addApp, getAppDetail, putApp } from '@/api/application'
import { getAuthTree } from '@/api/auth'
import { ElMessage } from 'element-plus'
import { validateEMail, validatePhone } from '@/utils/rules.js'
import { getApiOptionLists } from '@/api/api'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    roleId: {
        type: String,
        required: false
    }
})
const dialogTitle = ref('')

const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    name: '',
    callback_url: '',
    contact: '',
    phone: '',
    email: '',
    remark: '',
    status: 1,
    page: 1,
    page_size: 10,
    list_order: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入应用名称'
        }
    ],
    phone: [{ validator: validatePhone, trigger: 'blur' }],
    email: [{ validator: validateEMail, trigger: 'blur' }]
})

const submitLoading = ref(false)
const formRef = ref(null)
const treeRef = ref(null)
const apiOptionListsData = ref([])
// 获取所有权限
const allAuthsData = ref([])
const dogetAuthTree = async (filter) => {
    allAuthsData.value = await getAuthTree()
}

// 关闭
const closed = () => {
    emits('update:modelValue', false)
    dialogTitle.value = ''
    formRef.value && formRef.value.resetFields()
    treeRef.value && treeRef.value.setCheckedKeys([], false)
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.roleId !== '') {
        await doPutApp()
    } else {
        await doAddApp()
    }
}

// 修改app
const doPutApp = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await putApp(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 修改成功
        emits('updateForm')
        ElMessage.success('修改成功！')
        submitLoading.value = false
        closed()
    })
}

// 添加app
const doAddApp = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await addApp(formData.value).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 添加成功
        emits('updateForm')
        ElMessage.success('添加成功！')
        submitLoading.value = false
        closed()
    })
}

// 获取app详情
const doGetAppDetail = async () => {
    const data = await getAppDetail(props.roleId)
    dialogTitle.value = '-' + data.name
    formRef.value.resetFields()
    formData.value = data
}
const getApiOptionListsData = async () => {
    const data = await getApiOptionLists()
    const result = data.map((v) => v.key)
    apiOptionListsData.value = [...new Set(result)]
}

// 只有roleId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.roleId) {
            doGetAppDetail()
            getApiOptionListsData()
        } else {
            // 置空
            formData.value = {
                api_lists: null,
                name: '',
                callback_url: '',
                contact: '',
                phone: '',
                email: '',
                remark: '',
                status: 1,
                page: 1,
                page_size: 10,
                list_order: 1,
                visible: 1
            }
        }
    }
)

onActivated(() => {
    dogetAuthTree()
})
</script>

<style lang="scss" scoped>
.el-checkbox {
    display: block;
}
.checkbox-group {
    overflow-y: auto;
}
.el-form {
    max-height: 500px;
    overflow: auto;
}
</style>
